import React from 'react'

class SkeletonLoader extends React.PureComponent {
    
    render () {
        var skeletonBackgroundColor = "#3a3939";
        if(window.settings.brand.general && window.settings.brand.general.skeletonColor && window.settings.brand.general.skeletonColor !== "") {
            skeletonBackgroundColor = window.settings.brand.general.skeletonColor
        }
          var style1= {
            "background": "none"
          }
          var style2= {
            "background-color": skeletonBackgroundColor,
            "height":"600px",
            "margin-bottom": "10px"
          }
          if(window.innerWidth < 1025) {
            style2= {
                "background-color": skeletonBackgroundColor,
                "height":"450px",
                "margin-bottom": "10px"
              }  
          }
          if(window.innerWidth < 700) {
            style2= {
                "background-color": skeletonBackgroundColor,
                "height":"225px",
                "margin-bottom": "10px"
              }  
          }
          var style3= {
            "opacity": 1,
            "transform": "translate3d(0px, 0px, 0px)",
            "width": "8610px",
            "height":"288px"
          }
          var style4= {
              "padding":"20px",
              "overflow":"hidden"

          }
          var style5 = {
            "width": "205px",
            "background-color": skeletonBackgroundColor,
            "margin":"0 5px"
          }
          if(window.innerWidth < 700) {
            style5= {
                "width": "135px",
                "background-color": skeletonBackgroundColor,
                "margin":"0 5px",
                "height": "190px"
              }  
          }
          var style6 = {
            "height": "70px",
            "background-color": skeletonBackgroundColor,
          }
          var style7 = {
            "background-color": skeletonBackgroundColor,
            "height":"30px",
            "width": "300px",
            "margin-bottom": "10px"
          }
          if(window.innerWidth < 700) {
            style7= {
                "background-color": skeletonBackgroundColor,
                "height":"30px",
                "width": "165px",
                "margin-bottom": "10px"
              }  
          }
          var style8 = {
              "margin-bottom": "10px",
              "height": "70px",
              "background-color": skeletonBackgroundColor
          }
          if(window.innerWidth < 700) {
            style8= {
                "margin-bottom": "10px",
                "height": "50px",
                "background-color": skeletonBackgroundColor
              }  
          }
          var items = {
            "margin": "0"
        }
    return (
    <div style={style4}>
        <div className="ssrmodule" style={style8}>
        </div>
        <div className="ssrmodule" style={style2}></div>
        <div className="module">
            <div className="video-tray portrait">
                <div className="tray-wrapper-common">
                    <div className="BlockTitle-ssr site-color" style={style7}></div>
                </div>
                <div style={items}>
                    <div className="slick-initialized slick-slider">
                        <div className="slick-list">
                            <div className="slick-track" style={style3}>
                                <div data-index="0" className="slick-slide-ssr slick-active" tabindex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="1" className="slick-slide-ssr slick-active" tabindex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="2" className="slick-slide-ssr slick-active" tabindex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="3" className="slick-slide-ssr slick-active" tabindex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="4" className="slick-slide-ssr slick-active" tabindex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="5" className="slick-slide-ssr slick-active" tabindex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="6" className="slick-slide-ssr slick-active" tabindex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="7" className="slick-slide-ssr slick-active" tabindex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="8" className="slick-slide-ssr" tabindex="-1" style={style5}>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )}
}

export default SkeletonLoader